import AutomationPostModalBackButton from './AutomationPostModalBackButton';

export default AutomationPostModalBackButton;
